/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/31
 * @updateTime 2021/8/31
 * @decription 我的保全 =》 请求js
 * @namespace 【request】 请求
 */
import request from '@/api/axios';
export default {
    // 方法
    methods: {

        /**
         * 获取保全复议裁定信息
         * @param {Object} params 请求参数
         * @returns {Promise}
         * */
        requestFyfzbqxx(params) {
            return request({
                url: 'ssbq/api/fy/fyfzbqxx',
                method: 'get',
                params:{
                    time: new Date().getTime(),
                    ...params
                },
            });
        },
        /**
         * 解除保全申请列表
         * @param params
         */
        getJcbqsqList(params) {
            return request({
                url: 'ssbq/api/ssbq/jc/list',
                method: 'get',
                params: {
                    time: new Date().getTime(),
                    ...params
                },
            })
        }
    }
};

